"use strict"

window.app = window.app || {}

window.app = ((app) => {

    NodeList.prototype.forEach = Array.prototype.forEach

    app.initCallbacks = []
    app.addInitCallback = function(fn) {
        app.initCallbacks.push(fn)
    }

    app.init = () => {
        app.initCallbacks.forEach(cb => cb(app))
        
        const
            mqMobile = window.matchMedia("(max-width: 720px)"),
            mqMobileTablet = window.matchMedia("(max-width: 960px)"),
            mqTablet = window.matchMedia("(max-width: 960px) and (min-width: 721px)")

        // SIDE MENU
        let sideMenu = document.querySelector(".side-menu")
        if(sideMenu) {
            sideMenu.querySelector(".side-menu__btn")
                .addEventListener("click", e => {
                    e.preventDefault()
                    if(sideMenu.classList.contains("side-menu--open"))
                        sideMenu.classList.remove("side-menu--open")
                    else
                        sideMenu.classList.add("side-menu--open")
                })

            const
                forEach = Array.prototype.forEach,
                find = Array.prototype.find,
                classnameActive = "menu-item--active",
                classnameActual = "menu-link--actual",
                classnameDropdown = "menu-item--dropdown"

            // INIT DROPDOWN
            // const initItemDropdown = item => {
            //     const
            //         link = find.call(item.children, child => child.classList.contains("menu-link")),
            //         linkArr = find.call(link.children, child => child.classList.contains("menu-link-arr"))
            //     forEach.call(item.children, child => {
            //         if(child.classList.contains("menu-list")) {
            //             linkArr.addEventListener("click", e => {
            //                 e.preventDefault()
            //                 if(item.classList.contains(classnameActive))
            //                     item.classList.remove(classnameActive)
            //                 else
            //                     item.classList.add(classnameActive)
            //             })
            //         }
            //     })
            // }
            //
            // forEach.call(sideMenu.querySelectorAll("."+classnameDropdown), initItemDropdown)
            //
            // // SET INITIAL MENU STATE
            // const actualLink = find.call(sideMenu.querySelectorAll(".menu-link"), link => link.classList.contains(classnameActual))
            // if(actualLink) {
            //     const openParentDropdowns = el => {
            //         const parent = el.parentElement
            //         if(parent.classList.contains("side-menu"))
            //             return
            //
            //         if(parent.classList.contains(classnameDropdown))
            //             parent.classList.add(classnameActive)
            //
            //         openParentDropdowns(parent)
            //     }
            //
            //     openParentDropdowns(actualLink)
            // }
        }

        init_light_box();

        // tabulky, které nemají třídu no-wrap obalit do divu table-wrapper
        $('table').not('.no-wrap').wrap("<div class='table-wrapper'></div>");

        $(document.body).on("click", "a.ajax", function (event) {
            event.preventDefault();
            $.get(this.href);
            $(".ajax-spinner").show();
        });

        $(document.body).on('submit', 'form.ajax', function() {
            $(this).ajaxSubmit();
            return false;
        });

        // odeslání formuláře webtextu ajaxem - formuláři je potřeba nastavit třídu wtajax
        $('form.wtxajax').on('submit', function () {
            var $that = $(this);
            if ($that.data('htmlid') !== undefined) { // z formuláře vyrušit onsubmit a doplnit data-htmlid
                if (!webx_validate_form($that.data('htmlid'))) {
                    return false;
                }
            }
            $that.prevAll('.report').remove(); // odstranit předchozích reportů

            $(this).ajaxSubmit(function(payload){
                jQuery(".ajax-spinner").hide();

                if (payload.report) {

                    // přidání reportu
                    var $rep = $('<p>');
                    $rep.addClass('report');
                    $rep.addClass(payload.report.type);
                    $rep.html(payload.report.txt);
                    $that.before($rep);

                    if (payload.report.clean_form) { // vyprázdnit formulář
                        $('input[type=text],input[type=password],textarea', $that).val('');
                        $('input[type=checkbox]', $that).prop('checked', false);
                    }
                    if (payload.report.remove_form) { // odstraň formulář
                        $that.remove();
                    }

                }

            });
            return false;
        });

        // zavírání/otvírání bloků
        $('.titlebox.open>.titlebox-content').slideDown();
        $('.titlebox>h2.titlebox-title').click(function(ev){
            var $parent = $(this).parent();
            var was_opened = $parent.hasClass('open');
            $('.titlebox.open').each(function(){
                var $el = $(this);
                $('.titlebox-content', $el).slideUp();
                $el.removeClass('open');
            });
            if (!was_opened) {
                $parent.addClass('open');
                $('.titlebox-content', $parent).slideDown();
            }
            ev.preventDefault();
            return false;
        });


        // SLIDESHOW
        if(document.querySelector("header .slideshow")) {
            document.querySelector("header .slideshow .arr.arr-left")
                .addEventListener("click", e => {
                    app.slideshow.set[0].prevSlide()
                    e.preventDefault()
                })
            document.querySelector("header .slideshow .arr.arr-right")
                .addEventListener("click", e => {
                    app.slideshow.set[0].nextSlide()
                    e.preventDefault()
                })
        }

        // SEARCH BOX
        const
            searchFieldOpenClass = "search-field--open",
            searchFieldBlur = "search-field--blur",
            searchFieldEl = document.querySelector(".top-panel .search-field")
        document.querySelector(".top-panel .search-btn")
            .addEventListener("click", e => {
                if(mqMobile.matches) {
                    if(!searchFieldEl.classList.contains(searchFieldOpenClass) && !searchFieldEl.classList.contains(searchFieldBlur)) {
                        searchFieldEl.classList.add(searchFieldOpenClass)
                        searchFieldEl.focus()
                        e.preventDefault()
                    } else {
                        console.log("send")
                    }
                }
            })

        document.querySelector(".top-panel .search-field")
            .addEventListener("blur", e => {
                if(mqMobile.matches) {
                    searchFieldEl.classList.remove(searchFieldOpenClass)
                    searchFieldEl.classList.add(searchFieldBlur)
                    setTimeout(() => searchFieldEl.classList.remove(searchFieldBlur), 1000)
                }
            })

        // MAIN MENU
        let timeout
        const
            classShow = "main-menu__submenu-wrap--show",
            classHide = "main-menu__submenu-wrap--hide",
            submenus = document.querySelectorAll(".main-menu .main-menu__submenu-wrap")

        const getSubmenuTopValue = (i, link) => {
            const
                row = Math.floor(i/2),
                maxRows = Math.floor(submenus.length/2),
                rowFromBottom = maxRows - row - 1,
                positionFromBottom = rowFromBottom * link.offsetHeight

            return `-${positionFromBottom}px`
        }

        const closeSubmenu = submenu => e => {
            if(!e.relatedTarget)
                return

            const isNextLink = e.relatedTarget.classList.contains("main-menu__link"),
                isSubmenu = e.relatedTarget.classList.contains("main-menu__submenu-wrap")
            if(isNextLink)
                submenu.classList.remove(classShow)
            else if(!isSubmenu) {
                submenu.classList.add(classHide)
                timeout = setTimeout(() => {
                    submenu.classList.remove(classShow)
                    submenu.classList.remove(classHide)
                }, 500)
            }
        }

        // RESIZE WHEN OPEN SUBMENU
        mqTablet.addListener(m => {
            const activeSubmenu = Array.prototype.reduce.call(submenus, (returnValue, submenu, i) => {
                if(submenu.classList.contains(classShow)) {
                    returnValue.item = submenu
                    returnValue.i = i
                }

                return returnValue
            }, {})

            if(!activeSubmenu.item)
                return

            if(m.matches)
                activeSubmenu.item.style.top = 0
            else
                activeSubmenu.item.style.top = getSubmenuTopValue(activeSubmenu.i, document.querySelector(".main-menu .main-menu__link"))
        })

        if(!mqMobileTablet.matches) {
            // DESKTOP
            Array.prototype.forEach.call(document.querySelectorAll(".main-menu .main-menu__link"), (link, i) => {
                link.addEventListener("mouseover", e => {
                    clearTimeout(timeout)
                    Array.prototype.forEach.call(submenus, submenu => {
                        submenu.classList.remove(classShow)
                        submenu.classList.remove(classHide)
                    })
                    submenus[i].classList.add(classShow)
                })
                link.addEventListener("mouseout", closeSubmenu(submenus[i]))
            })
            Array.prototype.forEach.call(submenus, (submenu, i) => submenu.addEventListener("mouseleave", closeSubmenu(submenu)))
        }
        else {
            // MOBILE & TABLET
            Array.prototype.forEach.call(document.querySelectorAll(".main-menu .main-menu__link"), (link, i) => {
                link.addEventListener("click", e => {
                    e.preventDefault()
                    const hasClassname = submenus[i].classList.contains(classShow)
                    Array.prototype.forEach.call(submenus, (submenu, i) => submenus[i].classList.remove(classShow))
                    if(!hasClassname) {
                        submenus[i].classList.add(classShow)
                        submenus[i].style.top = `0`
                        if(mqMobile.matches)
                            submenus[i].style.top = getSubmenuTopValue(i, link)
                    }
                })
            })

            Array.prototype.forEach.call(document.querySelectorAll(".main-menu .main-menu__submenu-icon-close"), icon => {
                icon.addEventListener("click", e => {
                    Array.prototype.forEach.call(submenus, (submenu, i) => submenus[i].classList.remove(classShow))
                })
            })

            // RESIZE
            const resizeCb = e => {
                const activeSubmenu = Array.prototype.reduce.call(submenus, (returnValue, submenu, i) => {
                    if(submenu.classList.contains(classShow)) {
                        returnValue.item = submenu
                        returnValue.i = i
                    }
    
                    return returnValue
                }, {})
    
                if(!activeSubmenu.item)
                    return

                activeSubmenu.item.style.top = `0`
                if(mqMobile.matches)
                    activeSubmenu.item.style.top = getSubmenuTopValue(activeSubmenu.i, document.querySelector(".main-menu .main-menu__link"))
            }
            window.addEventListener("orientationchange", resizeCb)
            window.addEventListener("resize", resizeCb)
        }

        // GALLERY
        // $('.magnific-photo-gallery').magnificPopup({
        //     type: 'image',
        //     delegate: "li a",
        //     gallery: {
        //         enabled: true
        //     }
        // })

        // ARR UP
        app.menuSliding.initMenu(document.querySelectorAll("footer .arr-up"))
    }

    app.tag = (name, attrs = {}) => {
        let el = document.createElement(name.toString())
        !!attrs && Object.keys(attrs).forEach(key => el.setAttribute(key, attrs[key]))
        return el
    }

    return app
})(window.app)